// This file is automatically generated. Do not edit manually.

import { ObjectAttributeValueWithField } from "src/api/generated/erp/common/objectAttributes/model/objectAttributeValueWithField";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace SitePartAttributesApi {
	export async function getPartAttributes(args: { partId: number }): Promise<Array<ObjectAttributeValueWithField>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sitePart/attributes/getPartAttributes",
			method: "POST",
			data: {
				partId: args.partId,
			},
		});
		return response as Array<ObjectAttributeValueWithField>;
	}

	export async function saveCatalogPartAttributesOfSitePart(args: {
		partId: number;
		attributes: Array<ObjectAttributeValueWithField>;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sitePart/attributes/saveCatalogPartAttributesOfSitePart",
			method: "POST",
			data: {
				partId: args.partId,
				attributes: args.attributes,
			},
		});
		return response as void;
	}
}
